import _ from 'underscore';

import {SchemaTag, TargetSample} from 'folder-items/FileConstants';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {RequestDetailsQuery} from 'requests/request-view/__generated/RequestDetailsQuery';

import makeSample from './makeSample';
import {PreparedUISampleGroup} from './PreparedSampleGroupConstants';

type SampleGroupGraphQL = ExtractByTypename<
  RequestDetailsQuery['request'],
  'RequestNode'
>['sampleGroups'][number];

type SampleGroupSampleGraphQL = SampleGroupGraphQL['samples'][number];

function getDisplayInfoGraphQL(sample: SampleGroupSampleGraphQL): {name: string; url: string | null} {
  if (sample.bioentity) {
    return {name: sample.bioentity.name, url: sample.bioentity.editUrl};
  } else if (sample.batch) {
    return {name: sample.batch.name, url: sample.batch.url};
  } else {
    return {name: sample.name ?? '', url: sample.url};
  }
}

export default function prepareSampleGroupsGraphQLForTable(
  sampleGroups: Array<SampleGroupGraphQL>
): Array<PreparedUISampleGroup> {
  return sampleGroups.map(({id, tagsJson, samples}) => {
    const targetSamplesById = _.indexBy(samples, (sample) => sample.id);
    const preparedTags = tagsJson.map((tag: SchemaTag) => ({
      ...tag,
      targetSamples: tag.targetSamples!.map((targetSample: TargetSample) => {
        // Fall back to the server-provided name/url when the sample lookup is missing.
        const sample = targetSample.id != null ? targetSamplesById[targetSample.id] : undefined;
        if (sample == null) {
          return makeSample({}, targetSample.id, targetSample.name, targetSample.url);
        }

        const {name, url} = getDisplayInfoGraphQL(sample);

        const batch = sample.batch;
        const containerId = sample.container?.id;
        const fileId = sample.bioentity?.id;

        return makeSample({batch, containerId, fileId}, sample.id, name, url);
      }),
    }));

    return {id, cid: id, tags: preparedTags};
  });
}
